var _path, _circle, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7025 16.2229H24.9966L22.2457 11.3603C22.1719 6.05424 17.8912 1.77588 12.6214 1.77588C7.30548 1.77588 2.99609 6.1294 2.99609 11.4997C2.99609 14.9258 4.74995 17.938 7.40011 19.67V26.2241H17.3018V22.8907H18.2025C20.1355 22.8907 21.7025 21.3237 21.7025 19.3907V16.2229Z",
    fill: "url(#paint0_linear_20141_159163)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11,
    r: 6,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8243 8.17574C15.0586 8.41005 15.0586 8.78995 14.8243 9.02426L10.0243 13.8243C9.78995 14.0586 9.41005 14.0586 9.17574 13.8243C8.94142 13.5899 8.94142 13.2101 9.17574 12.9757L13.9757 8.17574C14.2101 7.94142 14.5899 7.94142 14.8243 8.17574Z",
    fill: "#91919D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.17574 8.17574C9.41005 7.94142 9.78995 7.94142 10.0243 8.17574L14.8243 12.9757C15.0586 13.2101 15.0586 13.5899 14.8243 13.8243C14.5899 14.0586 14.2101 14.0586 13.9757 13.8243L9.17574 9.02426C8.94142 8.78995 8.94142 8.41005 9.17574 8.17574Z",
    fill: "#91919D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20141_159163",
    x1: 12.5,
    y1: 15.5,
    x2: 3.78926,
    y2: 27.6122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#848490"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#DCDCE4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadCross);
export default __webpack_public_path__ + "static/media/headCross.0a72c3665c733a87b383a5eb5628ddcc.svg";
export { ForwardRef as ReactComponent };